const GUID_EMPTY = "00000000-0000-0000-0000-000000000000";

export default class ReportOptions {
  constructor() {
    this.AdditionalNotes = null;
    this.DateChequeRequired = false;
    this.DateChequeRequiredHour = null;
    this.DateChequeRequiredMinutes = null;
    this.DateOfRequest = null;
    this.EmployerHasStores = false;
    this.EmployerId = GUID_EMPTY;
    this.IncludeChequeRequisition = false;
    this.IncludeGroupSummary = false;
    this.IncludeMemberDetails = false;
    this.IncludeTotal = false;
    this.InsuranceCarrierId = GUID_EMPTY;
    this.InsuranceCarrierName = null;
    this.Name = null;
    this.SignatureList = null;
    this.SignaturesRequired = false;
    this.StoreId = GUID_EMPTY;
    this.TrustFundId = GUID_EMPTY;
    this.User = null;
  }
}
